import * as z from 'zod'

import { materialColors, semanticColors } from '@gto/ui/theme/design-tokens'

export const Categories = [
  '72+ hours',
  'Under 24 hours',
  '24 to 48 hours',
  '48 to 72 hours',
] as const

export const categorySchema = z.enum(Categories)
export type CategoryOption = (typeof Categories)[number]

/**
 * Rendered as a plain CSS `background-color`, so these must be COLOUR VALUES. Three of them were
 * MUI theme paths (`success.main`) — invalid CSS, so the dots fell back to grey and only the one
 * hardcoded hex still showed. Read off the design tokens rather than re-hardcoded.
 */
export const CategoryColorMapping: Record<CategoryOption, string> = {
  'Under 24 hours': semanticColors.success.main,
  '24 to 48 hours': materialColors.yellow[300],
  '48 to 72 hours': semanticColors.warning.main,
  '72+ hours': semanticColors.error.main,
}
export const SubscriptionKind = ['Cash Game', 'Tournament'] as const

export const SubscriptionLevels = ['Starter', 'Premium', 'Elite', 'Ultra'] as const
export enum SubscriptionKindEnum {
  'Cash Game' = 1,
  'Tournament' = 2,
  'Spin & Go' = 3,
  'HUSNG' = 4,
  'Straddle + Ante' = 5,
}

export enum SubscriptionLevelEnum {
  'Starter' = 1,
  'Premium' = 2,
  'Elite' = 3,
  'Ultra' = 4,
}

export type SubscriptionType = (typeof SubscriptionKindEnum)[number]
export type SubscriptionLevel = (typeof SubscriptionLevelEnum)[number]

export const edgeCountToOneBucks = 100

export const EdgeHistoryTabsSchema = z.enum(['earnings', 'redemptions', 'audit'])
export type EdgeHistoryTab = z.infer<typeof EdgeHistoryTabsSchema>
export const edgeHistoryTabs = EdgeHistoryTabsSchema.options
